import { preact, $$ } from "../../Core/References";
import { CheckBox } from "../CheckBox/CheckBox";
import { DataControl, IDataControlProps } from "../DataControl/DataControl";
import { Select } from "../Select/Select";
import { TextBox } from "../TextBox/TextBox";


export interface IFlexDataProps extends IDataControlProps
{
    Descriptor?: string;
    onChange?: Function;
}

export class FlexDate extends DataControl<IFlexDataProps>
{
    private _chkCirca: CheckBox;
    private _selectMonth: Select;
    private _selectType: Select;
    private _txtBox: TextBox;

    constructor(props: IFlexDataProps)
    {
        super(props)
    }

    public setValue(flexDate)
    {
        this._selectType.setValue(flexDate?.Type || 2);
        this._renderType(flexDate?.Type || 2);
        this._chkCirca.setValue(flexDate && flexDate.IsCirca);

        if (flexDate?.RawYear && flexDate.Type === 3)
        {
            this._selectMonth.setValue(flexDate.RawMonth);
            this._txtBox.setValue(flexDate.RawYear);
        }
        else
        {
            let dateText = $$.formatFlexDate(flexDate, null ,true);
            this._txtBox.setValue(dateText);
        }
    }

    public getValue()
    {
        let date = this.getDate();
        if (!date)
        {
            return null;
        }

        return {
            Type: this._selectType.getValue(),
            IsCirca: this._chkCirca.getValue(),
            RawDay: date.getDate(),
            RawMonth: date.getMonth() + 1,
            RawYear: date.getFullYear(),
            RawHours: date.getHours(),
            RawMinutes: date.getMinutes(),
            RawSeconds: date.getSeconds()
        };
    }

    public focus(): void
    {
        this._selectType.focus();
    }

    private _renderType(type)
    {
        this._selectMonth.display(type == 3);
    }

    private _handleTypeChange(value)
    {
        this._renderType(this._selectType.getValue());
    }

    public getDate()
    {
        let txtVal = this._txtBox.getValue();
        if (!txtVal) 
        {
            return null;
        }
		txtVal = txtVal.toLowerCase();
        
		let date;
        let type = this._selectType.getValue();

        switch (type)
        {
            case 1:
                date = new Date(txtVal);
                break;
            case 2:
                date = new Date(txtVal);
                break;
            case 3:
                date = new Date(txtVal as any, this._selectMonth.getValue() - 1, 1);
                break;
            case 4:
				let val = parseInt(txtVal);
				if(txtVal.indexOf("b")> -1 && txtVal.indexOf("c") > -1)
				{
					val = val * -1;
				}
                date = new Date(val, 0, 1);  //0= January
				if(val > 0 || val < 1000)
				{
					date.setUTCFullYear(val);
				}
                break;
        }
        
        return date;
    }

    public render()
    {
        return (
            <span ref={(container) => this._registerContainer(container)}>
                <Select Descriptor={this.props.Descriptor}
                    ref={(selectType) => this._selectType = selectType}
                    style={{ marginRight: "5px" }}
                    items={[
                        { Key: 2, Value: "Date" },
                        { Key: 1, Value: "Date and Time" },
                        { Key: 3, Value: "Month/Year" },
                        { Key: 4, Value: "Year" }
                    ]}
                    onChange={this._handleTypeChange.bind(this)}
                />
                {
                    <Select
                        ref={(selectMonth) => this._selectMonth = selectMonth}
                        style={{ display: "none", marginRight: "5px" }}
                        items={[
                            { Key: 1, Value: "January" },
                            { Key: 2, Value: "February" },
                            { Key: 3, Value: "March" },
                            { Key: 4, Value: "April" },
                            { Key: 5, Value: "May" },
                            { Key: 6, Value: "June" },
                            { Key: 7, Value: "July" },
                            { Key: 8, Value: "August" },
                            { Key: 9, Value: "September" },
                            { Key: 10, Value: "October" },
                            { Key: 11, Value: "November" },
                            {Key: 12, Value: "December"}
                        ]} />
                }
                <TextBox ref={(txtBox) => this._txtBox = txtBox} style={{ width: "135px", marginRight: "5px" }} onChange={this.props.onChange} /> 
                <CheckBox text="Circa" ref={(chkCirca)=> this._chkCirca = chkCirca} />
                </span>
            );
    }
}